import styles from "./HeroStatsBar.module.scss";
import GalleryIcon from "@Icons/Gallery_icon";
import FlagLight from "@Icons/FlagLight";
import PayoutDisbursedIcon from "@Icons/PayoutDisbursedIcon";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

const HeroStatsBar = () => {
  const { t } = useTranslationHook();

  return (
    <div className={styles.statsBar}>
      <div className={styles.statsItem}>
        <div className={styles.statsIcon}>
          <GalleryIcon />
        </div>
        <div className={styles.statsTextInline}>
          <span className={styles.statsValue}>
            {t("scholarship.herov2.herostatsbar.applicants.count")}
          </span>
          <span className={styles.statsLabel}>
            {t("scholarship.herov2.herostatsbar.applicants.label")}
          </span>
        </div>
      </div>
      <div className={styles.statsDivider} />
      <div className={styles.statsItem}>
        <div className={styles.statsIcon}>
          <FlagLight />
        </div>
        <div className={styles.statsTextInline}>
          <span className={styles.statsValue}>
            {t("scholarship.herov2.herostatsbar.nationalities.count")}
          </span>
          <span className={styles.statsLabel}>
            {t("scholarship.herov2.herostatsbar.nationalities.label")}
          </span>
        </div>
      </div>
      <div className={styles.statsDivider} />
      <div className={styles.statsItem}>
        <div className={styles.statsIcon}>
          <PayoutDisbursedIcon />
        </div>
        <div className={styles.statsTextInline}>
          <span className={styles.statsValue}>
            {t("scholarship.herov2.herostatsbar.scholarships.amount")}
          </span>
          <span className={styles.statsLabel}>
            {t("scholarship.herov2.herostatsbar.scholarships.label")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default wrapperHOC(HeroStatsBar, {
  componentName: "HeroStatsBar-ScholarshipDesktop",
  showForChina: true,
});
